export const kinderConnectCaptureSubmitButton = 'kinder-connect-capture-submit-button';
